// extracted by mini-css-extract-plugin
module.exports = {"plot":"scaleStyles_plot__13t17","plotWrapper":"scaleStyles_plotWrapper__3PP4t"};